<template>
    <div id="Wrapper">
        <div id="ForgotPasswordContainer">
            <div class="ForgotPasswordContentContainer">
                <div class="InputLabel localize" data-key="text.email">メール</div>
                <input id="Email" type="text" />
                <div id="Feedback" class="localize" data-key="text.mailsent">
                    メールは送りました。メールボックスを確認してください。
                </div>
            </div>
            <div class="ForgotPasswordContentContainer">
                <div id="ForgotPasswordButton" class="Button ButtonGreen ForgotPasswordRegPageButton localize" data-key="text.request" @click="RequestPassword">要求する</div>
                <div id="RegisterButton" style="margin-top: 25px;" class="Button ButtonGreen ForgotPasswordRegPageButton localize" data-key="text.register" @click="OpenRegistration">登録する</div>
                <div id="LoginButton" class="Button ButtonGreen ForgotPasswordRegPageButton localize" data-key="text.login" @click="OpenLogin">ログイン</div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { ShowLoading } from '../utils/FullScreenLoading';

export default {
    mounted(){
        let self = this;

        let inp = document.getElementById('Email');
        inp.addEventListener('keypress', function(event)
        {
            if (event.key === 'Enter')
            {
                self.Request();
            }
        });
    },
    methods:{
        RequestPassword() 
        {
            ShowLoading(true, 'ローディング中');

            let data = {
                Email: document.getElementById("Email").value,
            };
            
            axios.post(process.env.VUE_APP_BACKEND_URL + "forgotpassword", data)
            .then(async response =>
            {
                console.log(response.data);
                var msg = document.getElementById("Feedback");
                if (msg != null)
                {
                    msg.style.opacity = "1.0";
                }
                ShowLoading(false);
            })
            .catch(error =>
            {
                ShowLoading(false);
                console.log("Received error", error);
                if (error.response.status == 400){
                    alert(error.response.data);
                }
            });
        },
        OpenRegistration()
        {
            this.$router.push('/register');
        },
        OpenLogin()
        {
            this.$router.push('/');
        },
    }
}
</script>

<style>
input
{
    height: 30px;
    border-radius: 10px;
}

#Wrapper
{
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: grid;
    justify-content: center;
    align-content: center;
}

#Feedback
{
    opacity: 0;
    transition: 0.2s;
    -moz-transition: 0.2s;
    -webkit-transition: 0.2;
    font-weight: bold;
}

#ForgotPasswordContainer
{
    padding: 30px 25px;
    background-color: rgb(90, 196, 189);
    border-radius: 20px;
    width: 400px;
    color: #fff;
}

#ForgotPasswordContainer input
{
    width: 100%;
}

.ForgotPasswordContentContainer
{

}

#ForgotPasswordButton
{

}

.ForgotPasswordRegPageButton
{
    display: grid;
    align-items: center;
    justify-content: center;
    height: 30px;
    border-radius: 8px;
}

.LinkText
{
    cursor: pointer;
    color: #00f;
}

.InputLabel
{
    font-weight: bold;;
    margin-bottom: 8px;
}

#ForgotPasswordContainer .ForgotPasswordContentContainer + .ForgotPasswordContentContainer
{
    margin-top: 20px;
}

.ForgotPasswordContentContainer div + div
{
    margin-top: 10px;
}
</style>